import { useTranslation } from "react-i18next";
import i18next from "src/i18n/config";
import { ExpiredWrapper } from "src/ui/shared/ExpiredWrapper";

import { withMetaDescription } from "@navigation/utils/withMetaDescription";
import { CustomAlert } from "@shared/CustomAlert/CustomAlert";

import { PageContainer } from "../shared/components/PageContainer";

import { WorkspaceConfigurationPanel } from "./components/WorkspaceConfigurationPanel/WorkspaceConfigurationPanel";
import { useWorkspacePageAccess } from "./hooks/useWorkspacePageAccess";

function WorkspaceConfigurationPage() {
    const { t } = useTranslation(["pages"]);
    const { canAccessConfigurationTab } = useWorkspacePageAccess();

    return (
        <PageContainer fullWidth={false}>
            <ExpiredWrapper>
                {canAccessConfigurationTab ? (
                    <WorkspaceConfigurationPanel />
                ) : (
                    <CustomAlert severity="info" title={t("pages:workspacePage.restricted.configuration.title")}>
                        {t("pages:workspacePage.restricted.configuration.description")}
                    </CustomAlert>
                )}
            </ExpiredWrapper>
        </PageContainer>
    );
}

export default withMetaDescription(WorkspaceConfigurationPage, {
    title: i18next.t("pages:workspacePage.pages.configuration.metaTitle"),
    description: i18next.t("pages:workspacePage.pages.configuration.metaDescription"),
});
